import { render, staticRenderFns } from "./Orgao.vue?vue&type=template&id=e4f176de&scoped=true&lang=pug&"
import script from "./Orgao.vue?vue&type=script&lang=js&"
export * from "./Orgao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f176de",
  null
  
)

export default component.exports